import { get } from "../utils";
import { mapState } from "vuex";
import { tiposDocumentos } from "@/config/constants";
import * as ACTIONS from "@/config/constants/action-types";

export default {
  data() {
    return {
      paramsUrl: window.location.href.substring(
        window.location.href.indexOf("?")
      ),
      model: this.$store.getters.getConsulta(),
      recaptchaLoaded: false,
      isProduction: PRODUCTION,
      tiposDocumentos: tiposDocumentos
    };
  },
  computed: {
    validarNumeroDocFechaNacimiento() {
      //Si el numero de doc es menor a 10 millones y nacio en 1955 o despues, es incompatible.
      if (this.model.numeroDoc < 10000000) {
        let fecha = this.model.fechaNacimiento.split("/");
        let fechaNacimiento = new Date(fecha[2], fecha[1], fecha[0]);

        let fechaReferencia = new Date(1954, 12, 31);
        if (fechaNacimiento > fechaReferencia) {
          return false; //No compatible
        }
      }
      return true;
    },
    ...mapState({
      /**
       * Forzar el DNI a DNE
       */
      forzarDNE: state => {
        return get(state, "forzarDNE.numeroDoc", false);
      }
    })
  },
  mounted() {
    this.$store.dispatch(ACTIONS.DO_IS_LOADING, false);
  },
  methods: {
    trackClick(el) {
      /**
       * Hacer un dispatch del evento click sobre un elemento
       * para trackear analítica
       */
      this.$store.dispatch(ACTIONS.DO_CLICK_TRACKING, el);
    },
    onCaptchaVerified(token) {
      this.model.captcha = token;
      this.$refs.recaptcha.reset();
      this.$store.dispatch(ACTIONS.DO_IS_LOADING, true);
      this.$store.dispatch(ACTIONS.DO_INTERNAL_LINK, "conocer oferta");
      this.$store.dispatch(ACTIONS.DO_CONSULTA, this.model);
    },
    onCaptchaExpired() {
      this.$refs.recaptcha.reset();
      this.$store.dispatch(ACTIONS.DO_IS_LOADING, true);
    },
    onCaptchaRendered() {
      /**
       * Recaptcha cargó correctamente
       */
      this.recaptchaLoaded = true;
    }
  }
};
